import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { TranslationKey } from "../../../../../../localization/translations"

export type ProductionCardMenuItem = Readonly<{
    id: TranslationKey
    icon: IconDefinition
    fallback: string
    onClick: () => void
    isDelete?: boolean
}>

type Props = Readonly<{
    anchorEl: HTMLElement | null
    items: ReadonlyArray<ProductionCardMenuItem>
    deleteClassName?: string
    onClose: () => void
}>

export function ProductionCardMenu({ anchorEl, items, deleteClassName, onClose }: Props) {
    return (
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
            {items.map(({ id, icon, fallback, onClick, isDelete }) => (
                <MenuItem
                    key={id}
                    className={isDelete ? deleteClassName : undefined}
                    onClick={() => {
                        onClose()
                        onClick()
                    }}
                >
                    <ListItemIcon>
                        <FontAwesomeIcon icon={icon} className={isDelete ? deleteClassName : undefined} />
                    </ListItemIcon>
                    <LocalizedStrict id={id}>
                        <ListItemText>{fallback}</ListItemText>
                    </LocalizedStrict>
                </MenuItem>
            ))}
        </Menu>
    )
}
